export default __webpack_public_path__ + "static/engineer-male-fa3356014609eb232062864ec2f1b442.png";